import Cashbacks from './Cashbacks';

export default Cashbacks;
